import { Typography } from "@mui/material";
import Breadcrumb from '../../components/Breadcrumbs/Breadcrumbs';
import CreditNoteFlowData from '../../components/Cashflow/CreditNoteList';

const CreditNote =() => {
    return(
    <>
      <Breadcrumb />
      <CreditNoteFlowData accountType={"Invoices"} type={'sale-credit-note'} />
    </>
    );
};
export default CreditNote;